import { useEffect, useState } from "react";
import { Save, Trash2, Loader2 } from "lucide-react";
import { toast } from "sonner";
import adminApi, { apiError } from "@/services/adminApi";

const inputCls = "w-full px-3 py-2 bg-zinc-800/80 border border-zinc-700/40 rounded-lg text-sm text-white placeholder-zinc-500 focus:outline-none focus:border-amber-500/50";
const emptyForm = { platform: "android", latest_version: "", min_version: "", download_url: "", changelog: "", force_update: false };

export default function VersionsPage() {
  const [versions, setVersions] = useState([]);
  const [form, setForm] = useState(emptyForm);
  const [saving, setSaving] = useState(false);

  const load = () => adminApi.versions().then(({ data }) => setVersions(data.versions)).catch(() => {});
  useEffect(() => { load(); }, []);

  const handleSave = async () => {
    if (!form.latest_version || !form.min_version) {
      toast.error("Versiya nömrələri mütləqdir");
      return;
    }
    setSaving(true);
    try {
      await adminApi.upsertVersion(form);
      toast.success("Versiya yeniləndi");
      setForm(emptyForm);
      load();
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setSaving(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Versiya qeydi silinsin?")) return;
    await adminApi.deleteVersion(id);
    load();
  };

  const editVersion = (v) => {
    setForm({
      platform: v.platform,
      latest_version: v.latest_version,
      min_version: v.min_version,
      download_url: v.download_url || "",
      changelog: v.changelog || "",
      force_update: v.force_update || false,
    });
  };

  return (
    <div data-testid="admin-versions-page">
      <h1 className="text-2xl font-bold mb-1">Mobil App Versiyaları</h1>
      <p className="text-sm text-zinc-500 mb-6">Mobil applar açılışda <code className="text-amber-400">/api/app/version?platform=android</code> yoxlayıb yeniləmə təklif edir</p>

      <div className="bg-zinc-900/60 border border-zinc-800 rounded-2xl p-5 mb-6 space-y-3 max-w-2xl">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
          <select value={form.platform} onChange={(e) => setForm({ ...form, platform: e.target.value })} className={inputCls} data-testid="version-platform-select">
            <option value="android">Android</option>
            <option value="ios">iOS</option>
            <option value="android_tv">Android TV</option>
            <option value="tizen">Tizen</option>
            <option value="webos">WebOS</option>
          </select>
          <input data-testid="version-latest-input" placeholder="Son versiya (1.2.0) *" value={form.latest_version} onChange={(e) => setForm({ ...form, latest_version: e.target.value })} className={inputCls} />
          <input data-testid="version-min-input" placeholder="Minimum versiya (1.0.0) *" value={form.min_version} onChange={(e) => setForm({ ...form, min_version: e.target.value })} className={inputCls} />
        </div>
        <input placeholder="Yükləmə linki (APK URL)" value={form.download_url} onChange={(e) => setForm({ ...form, download_url: e.target.value })} className={inputCls} />
        <textarea placeholder="Dəyişikliklər (changelog)" rows={3} value={form.changelog} onChange={(e) => setForm({ ...form, changelog: e.target.value })} className={inputCls} />
        <label className="flex items-center gap-2 text-sm text-zinc-400 cursor-pointer">
          <input type="checkbox" checked={form.force_update} onChange={(e) => setForm({ ...form, force_update: e.target.checked })} className="accent-amber-500" />
          Məcburi yeniləmə (köhnə versiya işləməsin)
        </label>
        <button data-testid="version-save-btn" onClick={handleSave} disabled={saving} className="flex items-center gap-2 px-5 py-2 bg-amber-500 hover:bg-amber-400 disabled:opacity-50 text-black font-semibold rounded-lg text-sm transition-colors">
          {saving ? <Loader2 className="w-4 h-4 animate-spin" /> : <Save className="w-4 h-4" />} Yadda saxla
        </button>
      </div>

      <div className="space-y-2">
        {versions.map((v) => (
          <div key={v.id} data-testid={`version-row-${v.platform}`} className="flex items-center gap-4 bg-zinc-900/60 border border-zinc-800 rounded-xl px-4 py-3 cursor-pointer hover:border-zinc-700" onClick={() => editVersion(v)}>
            <div className="flex-1 min-w-0">
              <p className="font-semibold text-sm capitalize">{v.platform.replace("_", " ")}</p>
              <p className="text-xs text-zinc-500">Son: {v.latest_version} · Min: {v.min_version} {v.force_update && <span className="text-red-400">· Məcburi</span>}</p>
            </div>
            <button onClick={(e) => { e.stopPropagation(); handleDelete(v.id); }} className="p-2 text-zinc-400 hover:text-red-400 transition-colors">
              <Trash2 className="w-4 h-4" />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
